'use client'
import { cloneElement, ReactElement, ReactNode, useRef } from 'react'
import { useOnClickOutside, useToggle } from '~/hooks'
import { Container, Drop } from './styles'

type DropdownProps = {
  elementClick: ReactElement,
  children: ReactNode,
  $options?: {
    top?: string,
    left?: string
  }
  customClose?: Function
}

export const Dropdown: React.FC<DropdownProps> = ({ children, elementClick, $options, customClose }) => {
  const ref = useRef(null)
  const { toggle, isTrue, setIsTrue } = useToggle()

  //verify clickOutside Dropdown
  useOnClickOutside(ref, () => (setIsTrue(false), customClose && customClose()))

  const onClose = () => {
    toggle()
    customClose && customClose()
  }

  return (
    <Container ref={ref}>
      {cloneElement(elementClick, { onClick: onClose })}
      {isTrue && (
        <Drop $options={$options} >
          {children}
        </Drop>
      )}
    </Container>
  )
}
